import * as React from 'react';
import { Button, ButtonProps, IconButton, styled, useTheme } from '@mui/material';

interface LeftRightIconButtonType {
  text: string;
  buttontype: 'lefticon' | 'righticon' | 'defaultIcon' | 'long' | 'calendar';
  icon: React.ReactElement;
  iconcolor: 'primary' | 'textPrimary';
}

interface CancelButtonType {
  buttontype: 'cancel';
  text?: string;
}
interface MainActionButtonType {
  text: string;
  buttontype: 'mainaction';
}
interface IconButtonType {
  buttontype: 'icon';
  icon: React.ReactElement;
}
interface ExpandButtonType {
  buttontype: 'expand';
  text: string;
}

interface BigButtonType {
  buttontype: 'big';
  selected?: boolean;
  text: string;
}

type Props = ButtonProps & (CancelButtonType | MainActionButtonType | LeftRightIconButtonType | IconButtonType | ExpandButtonType | BigButtonType);

const StyledExpandButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const StyledIconButton = styled(Button)<{ iconcolor?: string }>(({ theme, iconcolor }) => ({
  color: iconcolor === 'primary' ? theme.palette.primary.main : theme.palette.text.primary,
}));

const StyledBigButton = styled(Button)<{
  selected?: boolean;
}>(({ theme, selected }) => ({
  width: '100%',
  boorderRadius: 32,
  color: !selected ? theme.palette.text.primary : 'white',
  backgroundColor: selected ? theme.palette.primary.main : 'white',
  '&:hover': {
    backgroundColor: selected ? theme.palette.primary.main : 'white',
  },
}));

const ButtonComponent: React.FC<Props> = (props) => {
  const buttonVariant = props.buttontype === 'cancel' ? 'outlined' : 'contained';
  const theme = useTheme();
  if (props.buttontype === 'mainaction')
    return (
      <Button {...props} variant={buttonVariant}>
        {props.text}
      </Button>
    );
  if (props.buttontype === 'icon') return <IconButton {...props}>{props.icon}</IconButton>;
  if (props.buttontype === 'expand')
    return (
      <StyledExpandButton {...props} variant="text" size="small">
        {props.text}
      </StyledExpandButton>
    );
  if (props.buttontype === 'lefticon')
    return (
      <StyledIconButton {...props} startIcon={props.icon} iconcolor={props.iconcolor}>
        {props.text}
      </StyledIconButton>
    );
  if (props.buttontype === 'calendar')
    return (
      <StyledIconButton
        {...props}
        style={{
          borderRadius: 4,
          border: `1px solid ${theme.palette.primary.main}`,
          color: theme.palette.primary.main,
          padding: theme.spacing(1, 1.5),
        }}
        startIcon={props.icon}
        iconcolor={props.iconcolor}
      >
        {props.text}
      </StyledIconButton>
    );
  if (props.buttontype === 'righticon')
    return (
      <StyledIconButton {...props} endIcon={props.icon} iconcolor={props.iconcolor}>
        {props.text}
      </StyledIconButton>
    );
  if (props.buttontype === 'defaultIcon')
    return (
      <StyledIconButton {...props} startIcon={props.icon} variant="outlined" iconcolor={props.iconcolor} style={{ borderRadius: 20, borderColor: 'lightgray' }}>
        {props.text}
      </StyledIconButton>
    );
  if (props.buttontype === 'big')
    return (
      <StyledBigButton {...props} variant="outlined" selected={props.selected} style={{ borderRadius: 20, borderColor: 'lightgray' }}>
        {props.text}
      </StyledBigButton>
    );
  return (
    <Button {...props} variant={buttonVariant}>
      {props.text || 'Cancel'}
    </Button>
  );
};
export default ButtonComponent;
